import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_UPLOAD_FAILED_SCHEMA = Object.freeze({
  INPUT_ID: '',
  INPUT_LOCAL_ID: '',
  INPUT_TYPE: '',
});
const RECORD = generateSchema(TRACKING_UPLOAD_FAILED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_UPLOAD_FAILED_SCHEMA);

export class UploadFailedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.upload_failed;
  }

  get properties() {
    return this.toJS();
  }
}
